import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { AnimatedOutlet } from './AnimatedOutlet';
import { CitationsManagerPanel } from '@/components/citations';
import { EmailVerificationBanner } from '@/components/EmailVerificationBanner';
import { useUIStore } from '@/stores/uiStore';
import { useDevMode } from '@/hooks/useDevMode';
import { Wrench } from 'lucide-react';

export function AppLayout() {
  const { id: projectId } = useParams();
  const { toggleCitationsManager, citationsManagerProjectId } = useUIStore();
  const { isDevMode } = useDevMode();

  // Global keyboard shortcut for Citations Manager
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Cmd/Ctrl + Shift + C to toggle Citations Manager
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'c') {
        e.preventDefault();
        // Use current project ID if available
        toggleCitationsManager(projectId || citationsManagerProjectId || undefined);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [projectId, citationsManagerProjectId, toggleCitationsManager]);

  return (
    <div className="flex min-h-screen w-full bg-background">
      {isDevMode && (
        <div className="fixed top-2 right-2 z-50 flex items-center gap-1.5 px-2.5 py-1 bg-amber-500/90 text-amber-950 text-xs font-medium rounded-full shadow-lg">
          <Wrench className="w-3 h-3" />
          DEV MODE
        </div>
      )}
      <AppSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <EmailVerificationBanner />
        <main className="flex-1 overflow-auto">
          <AnimatedOutlet />
        </main>
      </div>
      <CitationsManagerPanel />
    </div>
  );
}
